import { render, staticRenderFns } from "./BuySectionDelivery.vue?vue&type=template&id=7b08753e&scoped=true&"
import script from "./BuySectionDelivery.vue?vue&type=script&lang=ts&"
export * from "./BuySectionDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./BuySectionDelivery.vue?vue&type=style&index=0&id=7b08753e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b08753e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,MoleculesBuySectionDeliveryModal: require('/var/www/packages/theme/components/molecules/BuySectionDeliveryModal.vue').default,MoleculesBuySectionDeliverySubscriptionDrawer: require('/var/www/packages/theme/components/molecules/BuySectionDeliverySubscriptionDrawer.vue').default})
